import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { KFooterElementDirection, KFooterElementPosition } from './types.js';

var PREFIX = "KFooter";
var classes = {
    kFooter: "".concat(PREFIX, "-kFooter"),
    listOfLinks: "".concat(PREFIX, "-listOfLinks"),
    link: "".concat(PREFIX, "-link"),
    boxSocialNetworksAndLanguage: "".concat(PREFIX, "-boxSocialNetworksAndLanguage"),
    listOfSocialNetworks: "".concat(PREFIX, "-listOfSocialNetworks"),
    socialNetwork: "".concat(PREFIX, "-socialNetwork"),
    socialNetworksLabel: "".concat(PREFIX, "-socialNetworksLabel")
};
var getAlignItemsForLinks = function (direction, position) {
    if ((direction === null || direction === void 0 ? void 0 : direction.toUpperCase()) === KFooterElementDirection.VERTICAL) {
        if ((position === null || position === void 0 ? void 0 : position.toUpperCase()) === KFooterElementPosition.LEFT) {
            return "flex-start";
        }
        else if ((position === null || position === void 0 ? void 0 : position.toUpperCase()) === KFooterElementPosition.RIGHT) {
            return "flex-end";
        }
        else {
            return "center";
        }
    }
    return "center";
};
var getFlexDirectionForSocialNetworksAndLanguage = function (socialNetworksLanguageDirection, rightComponent, leftComponent) {
    if (socialNetworksLanguageDirection === KFooterElementDirection.VERTICAL) {
        if (rightComponent) {
            return "column";
        }
        else if (leftComponent) {
            return "column-reverse";
        }
        else {
            return "column";
        }
    }
    if (rightComponent) {
        return "row";
    }
    else if (leftComponent) {
        return "row-reverse";
    }
    else {
        return "row";
    }
};
var getAlignItemsForSocialNetworksAndLanguage = function (direction, position, rightComponent, leftComponent) {
    if ((direction === null || direction === void 0 ? void 0 : direction.toUpperCase()) === KFooterElementDirection.VERTICAL &&
        (position === null || position === void 0 ? void 0 : position.toUpperCase()) !== KFooterElementPosition.CENTER) {
        if (rightComponent || leftComponent) {
            return "flex-end";
        }
    }
    return "center";
};
var getJustifyContent = function (position) {
    if ((position === null || position === void 0 ? void 0 : position.toUpperCase()) === KFooterElementPosition.LEFT) {
        return "flex-start";
    }
    else if ((position === null || position === void 0 ? void 0 : position.toUpperCase()) === KFooterElementPosition.RIGHT) {
        return "flex-end";
    }
    else {
        return "center";
    }
};
var getJustifyContentForKFooter = function (position, rightComponent, leftComponent) {
    if (!rightComponent && !leftComponent) {
        if ((position === null || position === void 0 ? void 0 : position.toUpperCase()) === KFooterElementPosition.LEFT) {
            return "flex-start";
        }
        else if ((position === null || position === void 0 ? void 0 : position.toUpperCase()) === KFooterElementPosition.RIGHT) {
            return "flex-end";
        }
        else {
            return "center";
        }
    }
    else {
        return "space-between";
    }
};
var StyledKFooter = styled(Box, {
    shouldForwardProp: function (prop) {
        return prop !== "linksUnderlined" &&
            prop !== "linksSize" &&
            prop !== "linksListHeight" &&
            prop !== "linksListWidth" &&
            prop !== "linksColorOnHover" &&
            prop !== "linksUnderlinedOnHover" &&
            prop !== "linksPadding" &&
            prop !== "linksDirection" &&
            prop !== "linksPosition" &&
            prop !== "borderColor" &&
            prop !== "verticalPadding" &&
            prop !== "backgroundColor" &&
            prop !== "rightComponent" &&
            prop !== "leftComponent" &&
            prop !== "socialNetworksLanguageDirection";
    }
})(function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var theme = _a.theme, backgroundColor = _a.backgroundColor, verticalPadding = _a.verticalPadding, borderColor = _a.borderColor, linksDirection = _a.linksDirection, linksPosition = _a.linksPosition, linksPadding = _a.linksPadding, linksUnderlined = _a.linksUnderlined, color = _a.color, linksSize = _a.linksSize, linksListHeight = _a.linksListHeight, linksListWidth = _a.linksListWidth, linksUnderlinedOnHover = _a.linksUnderlinedOnHover, linksColorOnHover = _a.linksColorOnHover, rightComponent = _a.rightComponent, leftComponent = _a.leftComponent, socialNetworksLanguageDirection = _a.socialNetworksLanguageDirection;
    return (_b = {
            backgroundColor: backgroundColor || theme.palette.common.white,
            borderTop: "0.1em solid ".concat(borderColor || theme.palette.divider),
            paddingTop: verticalPadding || theme.spacing(5),
            paddingBottom: verticalPadding || theme.spacing(5)
        },
        _b["& .".concat(classes.kFooter)] = (_c = {},
            _c[theme.breakpoints.down("md")] = (_d = {
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    justifyContent: "center",
                    alignItems: "center"
                },
                _d["& .".concat(classes.listOfLinks)] = {
                    flexDirection: "column",
                    gap: "1rem"
                },
                _d),
            _c.display = "flex",
            _c.flexDirection = "row",
            _c.alignItems = "center",
            _c.justifyContent = getJustifyContentForKFooter(linksPosition, rightComponent, leftComponent),
            _c),
        _b["& .".concat(classes.boxSocialNetworksAndLanguage)] = (_e = {},
            _e[theme.breakpoints.down("md")] = {
                flexDirection: leftComponent ? "column-reverse" : "column",
                alignItems: "center"
            },
            _e.display = "flex",
            _e.flexDirection = getFlexDirectionForSocialNetworksAndLanguage(socialNetworksLanguageDirection, rightComponent, leftComponent),
            _e.alignItems = getAlignItemsForSocialNetworksAndLanguage(),
            _e.justifyContent = "flex-end",
            _e.gap = "1rem",
            _e.flexWrap = leftComponent ? "wrap-reverse" : "wrap",
            _e),
        _b["& .".concat(classes.listOfLinks)] = (_f = {},
            _f[theme.breakpoints.down("md")] = {
                flexDirection: "column",
                alignItems: "center"
            },
            _f.listStyleType = "none",
            _f.height = linksListHeight || "unset",
            _f.width = linksListWidth || "unset",
            _f.padding = 0,
            _f.margin = 0,
            _f.display = "flex",
            _f.flexWrap = "wrap",
            _f.flexDirection = linksDirection === KFooterElementDirection.VERTICAL ? "column" : "row",
            _f.justifyContent = getJustifyContent(linksPosition),
            _f.alignItems = getAlignItemsForLinks(linksDirection, linksPosition),
            _f.gap = "".concat(linksPadding || (linksDirection === KFooterElementDirection.HORIZONTAL ? "1rem 2" : 1), "rem"),
            _f.textAlign = linksDirection === KFooterElementDirection.VERTICAL &&
                linksPosition === KFooterElementPosition.CENTER
                ? "center"
                : "",
            _f),
        _b["& .".concat(classes.link)] = {
            textDecoration: linksUnderlined ? "underline" : "none",
            textDecorationColor: color || theme.palette.common.black,
            "& .linkLabel": {
                fontSize: "".concat(linksSize || 1, "em"),
                color: "".concat(color || theme.palette.common.black)
            },
            "&:hover": {
                textDecoration: linksUnderlinedOnHover ? "underline" : "none",
                textDecorationColor: linksColorOnHover || color || theme.palette.common.black,
                "& .linkLabel": {
                    color: "".concat(linksColorOnHover || color || theme.palette.common.black)
                }
            }
        },
        _b["& .".concat(classes.socialNetworksLabel)] = {
            textDecoration: "none",
            fontSize: "".concat(linksSize || 1, "em"),
            whiteSpace: "nowrap"
        },
        _b["& .".concat(classes.listOfSocialNetworks)] = (_g = {},
            _g[theme.breakpoints.down("md")] = {
                flexDirection: "column",
                alignItems: "center"
            },
            _g.listStyleType = "none",
            _g.width = linksListWidth || "unset",
            _g.padding = 0,
            _g.margin = 0,
            _g.display = "flex",
            _g.flexWrap = "wrap",
            _g.flexDirection = "row",
            _g.justifyContent = getJustifyContent(linksPosition),
            _g.alignItems = "center",
            _g.gap = "1.25rem",
            _g),
        _b["& .".concat(classes.socialNetwork)] = {
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            transition: "scale .2s ease-in",
            "&:hover": {
                scale: "1.095"
            }
        },
        _b);
});

export { classes, StyledKFooter as default };
//# sourceMappingURL=index.styled.js.map
